<template>
    <div :class="[$options.name, project.slug, portraitMode ? '-full-view' : '-split-view' ]" :ref="`project-${index}`">
        <div class="section-wrapper">
            <div class="cover" ref="cover">
                <div
                    class="cover-img"
                    :style="{ backgroundImage: `url(${getAssetFile(project)})` }"
                >
                </div>
            </div>
            <div class="primary-content" ref="infoContent">
                <div class="content-wrapper">
                    <h2 class="heading -xl" v-html="project.name"></h2>
                    <a
                        @click="slideInHero(project.slug)"
                        class="see-more-cta button"
                    >
                        <span class="txt">See more</span>
                        <div class="button__horizontal"></div>
                        <div class="button__vertical"></div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { gsap, Power3, easeInOut } from 'gsap'
export default {
    name: 'preview-project',
    props: ['project', 'index'],
    data() {
        return {
            modules: [],
            animate: false,
            isVisible: false
        }
    },
    computed: {
        projectName() {
            let name = this.project.name.split(' ')
            let html = ''
            name.forEach(word => {
                if (word) {
                    html += `<span class="highlight">${word}</span> `
                }
            })
            return html
        }
    },
    mounted() {
        let allProjectSlugs = this.projectsList.map(proj => proj.slug)
        this.$bus.$on(this.$bus.SCROLLING_PROJECTS, (payload) => {
            if (allProjectSlugs.includes(payload.origin.anchor)) {
                let prevSection = document.querySelector(`.${payload.origin.anchor}`)
                let cover = prevSection.querySelector('.cover')
                let content = prevSection.querySelector('.content-wrapper')
                let tl = gsap.timeline()
                tl.to(cover, 0.3, { x: '100%', opacity: 0, ease: Power3.easeInOut })
                tl.to(content, 0.3, { x: '-100%', opacity: 0, ease: Power3.easeInOut })
            }
            if (allProjectSlugs.includes(payload.destination.anchor)) {
                let nextSection = document.querySelector(`.${payload.destination.anchor}`)
                let cover = nextSection.querySelector('.cover')
                let content = nextSection.querySelector('.content-wrapper')
                let xPos = this.portraitMode ? '-50%' : '0%'
                let tl = gsap.timeline()
                tl.to(cover, 0.5, { x: '0%', opacity: 1, ease: Power3.easeInOut })
                tl.to(content, 0.5, { x: xPos, opacity: 1, ease: Power3.easeInOut }, '-=0.3')
            }
        })
    },
    methods: {
        getAssetFile(project) {
            return require(`../assets/images/${project.slug}/${project.coverImg}`)
        },
        goToProjectRoute(slug) {
            this.$router.push({ name: 'project', params: { slug: slug } })
        },
        slideInHero(slug) {
            let img = this.$refs.cover.querySelector('.cover-img')
            this.tl = gsap.timeline()
            let duration = 0.8
            if (!this.isMobileSize) {
                this.tl
                    .to(
                        this.$refs.cover,
                        duration,
                        {
                            left: 0,
                            width: '100%'
                        }
                    )
                    .to(
                        img,
                        duration,
                        {
                            webkitClipPath:'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'
    
                        },
                        `-=${duration}`
                    )
            } else {
                this.tl.to(this.$refs.cover, duration, { opacity: 0 })
            }
            this.tl.to(
                this.$refs.infoContent,
                duration,
                {
                    left: -500,
                    onComplete: this.goToProjectRoute,
                    onCompleteParams: [slug]

                },
                `-=${duration}`
            )
        }
    }
}
</script>
<style lang="scss" scoped>
$coverHeight: 50%;

.preview-project {
    .section-wrapper {
        height: 100%;
        position: relative;
    }
    .cover {
        opacity: 0;
        .cover-img {
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
        }
    }
    .primary-content {
        position: relative;
        .content-wrapper {
            opacity: 0;
            top: 50%;
            position: absolute;
            transform: translateY(-50%) translateX(-100%);
        }
    }
    &.-full-view {
        .section-wrapper {
            padding: $headerHeight 0 2rem;
            @include g-state(tablet) {
                padding: $headerHeightDesktop 0;
            }
        }
        .cover {
            height: $coverHeight;
            width: 100%;
            .cover-img {
                left: 50%;
                width: 90%;
                height: 100%;
                position: absolute;
                transform: translateX(-50%);
            }
        }
        .primary-content {
            height: calc(100% - #{$coverHeight});
            .content-wrapper {
                left: 50%;
                opacity: 0;
                text-align: center;
                position: absolute;
                .heading.-xl {
                    font-size : 9vw;
                }
            }
        }

    }
    &.-split-view {
        padding-top: 0;
        .cover {
            top: 0;
            right: 0;
            width: 65%;
            height: 100%;
            position: absolute;
            transform: translateX(100%);
            .cover-img {
                width: 100%;
                height: 100%;
                clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 25% 100%);
            }
        }
        .primary-content {
            top: 0;
            width: 40%;
            height: 100%;
            .content-wrapper {
                left: 8%;
                text-align: left;
                transform: translateY(-50%);
                .heading.-xl {
                    font-size : 6.5vw;
                }
            }
        }
    }
}
</style>